module.exports = __webpack_public_path__ + "static/home-desktop-lead-space-13d028a449b6847640623abbbb4845de.svg";